module.exports = __webpack_public_path__ + "e4ef8cfea83f0eb3872bfab6460ffc99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/agf_investments.png
// module id = 1783
// module chunks = 0